import React from "react";
import {atom} from "jotai";
import {AIServiceCaptionListProps, AITransServiceListProps, CaptionItemProps, CaptionListProps} from "../types/caption";
import { Segment, SegmentAddOptions } from "peaks.js";



export const segmentsAtom = atom<SegmentAddOptions[]>([])

export const captionListState = atom<CaptionListProps[]>([{
  seq: 1,
  time_ini: "",
  time_end: "",
  caption: "",
  color : "black",
  editable : true,
  endTime : 0,
  startTime : 0,
  id : "0",
  labelText : "",
}])

export const AIcaptionListState = atom<CaptionListProps[]>([{
  seq: 1,
  time_ini: "",
  time_end: "",
  caption: "",
  color : "black",
  editable : true,
  endTime : 0,
  startTime : 0,
  id : "0",
  labelText : "",
}])

export const latestSavedCaptionAtom = atom<{current : CaptionListProps[] | null } >({current : null})

export const captionItemState = atom<CaptionItemProps>({
  currentCaptionId: 1,
  intervalCaptionId: 0,
  intervalCaptionOn: false,
  captionSelectedId: 0,
  captionSelectedOn: false,
  intervalCaptionSelectedIds: []
})

export const AITransServiceListState = atom<AITransServiceListProps[]>([{
  trans_srt_id: "",
  trans_port: 0,
  trans_path: "",
  trans_service: "",
  trans_url: ""
}])


export const AIServiceCaptionListState = atom<AIServiceCaptionListProps[]>([{
  AIServiceName: "",
  AICaptionList: [{
    seq: 1,
    time_ini: "",
    time_end: "",
    caption: ""
  }]
}])
